/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../components/Context/GloablContext';
import { setProviderSearch, resetProviderSearch } from '../../../../redux/providerSearchSlice';
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../../../components/DateField';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export default function ProviderSearch({handleOnSubmit,emptyField,setEmptyField,monitorPageSearch,organizationUserSearch}) {
    const providerSearch = useSelector(state => state.providerSearchData);
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state.providerSearchData.prosearchApplied);

    
    // handleOnChangeUserDetails function
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;

        // Restrict input to only numbers, #, and * for specific fields
        if (['mobile_number', 'main_number', 'main_number_code', 'mobile_number_code', 'npi_number'].includes(id)) {
            updatedValue = value.replace(/[^0-9*-]/g, '');
        }

        // Handle only string values with trim, otherwise leave the value as is
        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue.trim();
        }

        const updatedState = { ...providerSearch, [id]: updatedValue };

        // Special cases for username and email
        if (['user_name', 'user_name_domain'].includes(id)) {
            const isBothUserNameFieldsEmpty = updatedState.user_name === '' && updatedState.user_name_domain === '';
            if (isBothUserNameFieldsEmpty && updatedState.user_name_inverse === 'true') {
                updatedState.user_name_inverse = '';
            }
        } else if (['email_address', 'email_address_domain'].includes(id)) {
            const isBothEmailFieldsEmpty = updatedState.email_address === '' && updatedState.email_address_domain === '';
            if (isBothEmailFieldsEmpty && updatedState.email_address_inverse === 'true') {
                updatedState.email_address_inverse = '';
            }
        } else {
        // Uncheck `mobile_number_inverse` if both mobile fields are empty
            if ((id === 'mobile_number' || id === 'mobile_number_code') &&
            updatedState.mobile_number === '' && 
            updatedState.mobile_number_code === '' &&
            updatedState.mobile_number_inverse === 'true') 
            {
                updatedState.mobile_number_inverse = '';
            }

            // Uncheck `main_number_inverse` if both main number fields are empty
            if ((id === 'main_number' || id === 'main_number_code') &&
            updatedState.main_number === '' && 
            updatedState.main_number_code === '' &&
            updatedState.main_number_inverse === 'true') 
            {
                updatedState.main_number_inverse = '';
            }

            // Default handling for other fields
            if (!['mobile_number', 'mobile_number_code', 'main_number', 'main_number_code'].includes(id) && 
            updatedValue === '' && 
            updatedState[`${id}_inverse`] === 'true') 
            {
                updatedState[`${id}_inverse`] = '';
            }
        }

        // Dispatch the updated state to Redux
        dispatch(setProviderSearch(updatedState));
    };

    // handleCheckboxChange function
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;

        // Update state based on checkbox status
        const updatedState = { ...providerSearch, [field]: checked ? 'true' : '' };

        // Dispatch the updated state to Redux
        dispatch(setProviderSearch(updatedState));
    };

    const dateformatSysconfig = useSelector(
        (state) => state?.systemConfigData?.globalVariables?.date_format
    );

    const [dateFormat, setDateFormat] = useState('dd/mm/yyyy');

    // Update date format from sysconfig
    useEffect(() => {
        if (dateformatSysconfig) {
            const format = dateformatSysconfig.split(',')[0].toLowerCase();
            setDateFormat(format === 'mm/dd/yyyy' ? 'mm/dd/yyyy' : 'dd/mm/yyyy');
        }
    }, [dateformatSysconfig]);
    
    /**
     * The function `handleDateChange` validates and updates date input fields in a React application.
     */
    const handleDateChange = (newDate) => {
        setEmptyField(false);
        // Validate input: only numbers, and apply limits
        const validatedDay = /^[0-9]*$/.test(newDate.day) && newDate.day <= 31 ? newDate.day : '';
        const validatedMonth = /^[0-9]*$/.test(newDate.month) && newDate.month <= 12 ? newDate.month : '';
        const validatedYear = /^[0-9]*$/.test(newDate.year) ? newDate.year : '';
    
        // Check if the date is fully cleared
        const isDateCleared =
            !validatedDay.trim() && !validatedMonth.trim() && !validatedYear.trim();
    
        dispatch(setProviderSearch({
            ...providerSearch,
            created_day: validatedDay,
            created_month: validatedMonth,
            created_year: validatedYear,
            // Uncheck the checkbox if the date fields are cleared
            created_date_inverse: isDateCleared ? '' : providerSearch.created_date_inverse,
        }));
    };
    
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {
            dispatch(resetProviderSearch());
        }
    };

    /**
     * The function `isApplyButtonDisabled` checks if all values in the `providerSearch` object are
     * considered empty based on their type.
     * @returns The function `isApplyButtonDisabled` is returning a boolean value. It checks all
     * key-value pairs in the `providerSearch` object and returns `true` if all conditions are met for
     * each value to be considered as 'empty'.
     */
    const isApplyButtonDisabled = () => {
        return Object.entries(providerSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetProviderSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setSearchParams(Object.fromEntries(updatedParams.entries()));
        setEmptyField(false);
    };

    /* The above code is using the `useEffect` hook in React to add an event listener for the "keydown"
    event on the window object. When a key is pressed, it checks if the key pressed is the "Escape"
    key, and if so, it calls the `handleClearAll` function. The `useEffect` hook also includes a
    cleanup function that removes the event listener when the component unmounts or when the
    dependencies array is empty. */
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    /* The above code snippet is a React useEffect hook that is triggered when the
    `isAdvancedSearchOpen` dependency changes. Within the useEffect hook, it performs the following
    actions: */
    useEffect(() => {      
        dispatch(resetProviderSearch())  
        const params = Object.fromEntries(searchParams);
               
        if (params.search) {
            // Decode the search string to get individual fields
            const searchDecoded = decodeURIComponent(params.search);
               
            // Existing matches for user_id, first_name, last_name and other states
            const userIdMatch = searchDecoded.match(/user_id=(ne:)?(.+?)(;|$)/);
            const userNameMatch = searchDecoded.match(/user_name=(ne:)?(.+?)(;|$)/);
            const emailMatch = searchDecoded.match(/email_address=(ne:)?(.+?)(;|$)/);
            const mainNumberMatch = searchDecoded.match(/(main_no_country_code-main_number|main_country_code-main_number)=(ne:)?(.+?)(;|$)/);
            const mobileNumberMatch = searchDecoded.match(/(mob_no_country_code-mobile_number|mobile_country_code-mobile_number)=(ne:)?(.+?)(;|$)/);
            const firstNameMatch = searchDecoded.match(/first_name=(ne:)?(.+?)(;|$)/);
            const lastNameMatch = searchDecoded.match(/last_name=(ne:)?(.+?)(;|$)/);
            const npiMatch = searchDecoded.match(/npi_number=(ne:)?(.+?)(;|$)/);
            const createdDateMatch = searchDecoded.match(/created_at=(ne:)?(\d+)(;|$)/);

            // Build the new state
            const updatedState = {};
               
            // handle user_id field
            if (userIdMatch) {
                const isInverse = !!userIdMatch[1]; 
                const tempIdValue = userIdMatch[2]; 
               
                updatedState.user_id = tempIdValue === '__NULL__' ? '-' : tempIdValue;
                updatedState.user_id_inverse = isInverse ? 'true' : '';
            }
                        
            // Handle first_name field
            if (firstNameMatch) {
                const isInverse = !!firstNameMatch[1];
                const firstNameValue = firstNameMatch[2];
                updatedState.first_name = firstNameValue === '__NULL__' ? '-' : firstNameValue;
                updatedState.first_name_inverse = isInverse ? 'true' : '';
            }
        
            // Handle last_name field
            if (lastNameMatch) {
                const isInverse = !!lastNameMatch[1];
                const lastNameValue = lastNameMatch[2];
                updatedState.last_name = lastNameValue === '__NULL__' ? '-' : lastNameValue;
                updatedState.last_name_inverse = isInverse ? 'true' : '';
            }
        
            // Handle npiMatch field
            if (npiMatch) {
                const isInverse = !!npiMatch[1];
                const npiValue = npiMatch[2];
                updatedState.npi_number = npiValue === '__NULL__' ? '-' : npiValue;
                updatedState.npi_number_inverse = isInverse ? 'true' : '';
            }
            
            // Handle assigned date field
            if (createdDateMatch) {
                const isInverse = !!createdDateMatch[1]; 
                const epochTime = createdDateMatch[2]; 
                        
                // Convert epoch time to a date
                const date = new Date(parseInt(epochTime, 10) * 1000); 
                        
                // Use getDate(), getMonth(), and getFullYear() for local time
                const day = date.getDate().toString().padStart(2, '0'); // Ensure day is two digits
                const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure month is two digits
                const year = date.getFullYear().toString(); 
                        
                // Update state with the correct date and inverse flag
                updatedState.created_day = day;
                updatedState.created_month = month;
                updatedState.created_year = year;
                updatedState.created_date_inverse = isInverse ? 'true' : ''; 
            }

            // Handle main_number field
            if (mainNumberMatch) {
                let mainNumberValue = mainNumberMatch[3]; // Extract the value after '='
                const isInverse = !!mainNumberMatch[2]; // Check if 'ne:' prefix is present
    
                // Process the main_number value
                if (mainNumberValue.startsWith('+')) {
                    mainNumberValue = mainNumberValue.slice(1); // Remove the '+' if present
                }
    
                const [mainCode, mainNumber] = mainNumberValue.split('-');
                updatedState.main_number_code = mainCode === '__NULL__' ? '-' : mainCode,
                updatedState.main_number= mainNumber === '__NULL__' ? '-' : mainNumber,
                updatedState.main_number_inverse= isInverse ? 'true' : '';
    
            }

            // // Handle mobile_nunmber field
            if (mobileNumberMatch) {
                let mobileNumberValue = mobileNumberMatch[3]; // Extract the value after '='
                const isInverse = !!mobileNumberMatch[2]; // Check if 'ne:' prefix is present
    
                // Process the mobile_number value
                if (mobileNumberValue.startsWith('+')) {
                    mobileNumberValue = mobileNumberValue.slice(1); // Remove the '+' if present
                }
    
                const [mobileCode, mobileNumber] = mobileNumberValue.split('-');
                updatedState.mobile_number_code = mobileCode === '__NULL__' ? '-' : mobileCode;
                updatedState.mobile_number = mobileNumber === '__NULL__' ? '-' : mobileNumber;
                updatedState.mobile_number_inverse = isInverse ? 'true' : '';
            }    

            // Handle user_name field
            if (userNameMatch) {
                const isInverse = !!userNameMatch[1]; // Check if 'ne:' prefix is present
                const userNameValue = userNameMatch[2]; // Extract the user_name value after 'ne:'
                const [namePart, domainPart] = userNameValue.split('@');
    
                updatedState.user_name = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.user_name_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.user_name_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }

            // Handle email_address field
            if (emailMatch) {
                const isInverse = !!emailMatch[1]; // Check if 'ne:' prefix is present
                const emailValue = emailMatch[2]; // Extract the email_address value after 'ne:'
                const [namePart, domainPart] = emailValue.split('@');

                updatedState.email_address = namePart === '__NULL__' ? '-' : namePart || ''; // Before '@' part
                updatedState.email_address_domain = domainPart === '__NULL__' ? '-' : domainPart || ''; // After '@' part
                updatedState.email_address_inverse = isInverse ? 'true' : ''; // Inverse checkbox
            }
                        
            // Handle search_mode if applicable
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or' ? true : false;
            }
               
            // Dispatch the action to update Redux state
            setTimeout(() => {
                dispatch(setProviderSearch(updatedState));
            }, 0);
        }
    }, [isAdvancedSearchOpen]);

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => {handleOnSubmit(e);
                }} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={providerSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${providerSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!providerSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!providerSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto pl-2 ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"ID"}
                                    placeholder={"Enter ID"}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={providerSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={15}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        onFocus={(e) => {
                                            e.type === 'focus' &&  dispatch(setProviderSearch({ ...providerSearch, ['user_id_inverse']: 'true'}));
                                        }}
                                        checked={providerSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Username</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"user_name"}
                                        data_testid={"user_name"}
                                        htmlFor={"user_name"}
                                        value={providerSearch?.user_name}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"user_name_domain"}
                                        data_testid={"user_name_domain"}
                                        htmlFor={"user_name_domain"}
                                        value={providerSearch.user_name_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_name_inverse')}
                                        checked={providerSearch.user_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.user_name_domain?.trim()===""&&providerSearch?.user_name?.trim()===""}
                                    />
                                    <label htmlFor='user_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"First Name"}
                                    placeholder={"Enter first name"}
                                    id={"first_name"}
                                    data_testid={"first_name"}
                                    htmlFor={"first_name"}
                                    value={providerSearch?.first_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='first_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'first_name_inverse')}
                                        checked={providerSearch?.first_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.first_name?.trim()===""}
                                    />
                                    <label htmlFor='first_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Last Name"}
                                    placeholder={"Enter last name"}
                                    id={"last_name"}
                                    data_testid={"last_name"}
                                    htmlFor={"last_name"}
                                    value={providerSearch?.last_name}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='last_name_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'last_name_inverse')}
                                        checked={providerSearch?.last_name_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.last_name?.trim()===""}
                                    />
                                    <label htmlFor='last_name_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Email Address</p>
                                <div className='w-full flex items-center'>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"example"}
                                        id={"email_address"}
                                        data_testid={"email_address"}
                                        htmlFor={"email_address"}
                                        value={providerSearch?.email_address}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                    <span className='mx-1 text-xs font-normal text-[#000000]'>@</span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"domain"}
                                        id={"email_address_domain"}
                                        data_testid={"email_address_domain"}
                                        htmlFor={"email_address_domain"}
                                        value={providerSearch?.email_address_domain}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={60}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='email_address_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'email_address_inverse')}
                                        checked={providerSearch?.email_address_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.email_address?.trim()===""&&providerSearch?.email_address_domain.trim()===""}
                                    />
                                    <label htmlFor='email_address_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Mobile Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"mobile_number_code"}
                                            data_testid={"mobile_number_code"}
                                            htmlFor={"mobile_number_code"}
                                            value={providerSearch?.mobile_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"mobile_number"}
                                        data_testid={"mobile_number"}
                                        htmlFor={"mobile_number"}
                                        value={providerSearch?.mobile_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='mobile_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'mobile_number_inverse')}
                                        checked={providerSearch?.mobile_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.mobile_number_code?.trim()==="" && providerSearch?.mobile_number?.trim()===""}
                                    />
                                    <label htmlFor='mobile_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <p className='text-xs font-normal text-[#000000] mb-1 more-lines'>Main Number</p>
                                <div className='w-full flex items-center'>
                                    <span className='mr-1 text-xs font-medium text-[#000000]'>+</span>
                                    <div className='w-[40%]'>
                                        <AdvancedSearchInputBox
                                            label={""}
                                            placeholder={""}
                                            id={"main_number_code"}
                                            data_testid={"main_number_code"}
                                            htmlFor={"main_number_code"}
                                            value={providerSearch?.main_number_code}
                                            handleOnChangeInput={handleOnChangeUserDetails}
                                            maxLength={3}
                                        />
                                    </div>
                                    <span className='mx-0.5 text-xs font-normal text-[#000000]'></span>
                                    <AdvancedSearchInputBox
                                        label={""}
                                        placeholder={"Enter number"}
                                        id={"main_number"}
                                        data_testid={"main_number"}
                                        htmlFor={"main_number"}
                                        value={providerSearch?.main_number}
                                        handleOnChangeInput={handleOnChangeUserDetails}
                                        maxLength={20}
                                    />
                                </div>
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='main_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'main_number_inverse')}
                                        checked={providerSearch?.main_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.main_number_code?.trim()==="" && providerSearch?.main_number?.trim()===""}
                                    />
                                    <label htmlFor='main_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {!monitorPageSearch && !organizationUserSearch && 
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"NPI Number"}
                                    placeholder={"Enter NPI number"}
                                    id={"npi_number"}
                                    data_testid={"npi_number"}
                                    htmlFor={"npi_number"}
                                    value={providerSearch?.npi_number}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='npi_number_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'npi_number_inverse')}
                                        checked={providerSearch?.npi_number_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.npi_number?.trim()===""}
                                    />
                                    <label htmlFor='npi_number_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        }
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <DateInput
                                    labeltext={'Created Date'}
                                    date={{
                                        day: providerSearch.created_day,
                                        month: providerSearch.created_month,
                                        year: providerSearch.created_year,
                                    }}
                                    onDateChange={handleDateChange}
                                    dateFormat={dateFormat}
                                    idPrefix="created"
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='created_date_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'created_date_inverse')}
                                        checked={providerSearch.created_date_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={providerSearch?.created_day?.trim()==="" || providerSearch?.created_month?.trim()==="" || providerSearch?.created_year?.trim()===""}
                                    />
                                    <label htmlFor='created_date_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}
                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
